<template>
  <div class="mt-[10px] pt-[20px] flex flex-col items-end justify-end">
    <div
      v-if="errorMessage"
      class="flex grow w-full rounded-lg bg-[#FFF2E2] px-3.5 py-2.5 gap-2.5 items-center justify-start border-[1px] border-[#FBA63C] mb-[20px]"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
        alt="info-circle"
      >
      <div class="text-[#333]">
        {{ errorMessage }}
      </div>
    </div>
    <div class="flex gap-[32px] sm:mr-[45px]">
      <div class="grow">
        <p>Total Order</p>
        <p>Total Biaya Fulfillment</p>
      </div>
      <div>
        <p>: {{ totalOrder }}</p>
        <p>: {{ totalFulfillmentFee | rupiah }}</p>
      </div>
    </div>
    <b-button
      variant="primary"
      class="!px-[40px] mt-[30px]"
      :disabled="!isAllowSubmit || isOnSubmit"
      @click="handleSubmitBulkUpload"
    >
      <b-spinner
        v-if="isOnSubmit"
        class="mr-1"
        small
      />
      {{ isOnSubmit ? 'Memproses...' : 'Ajukan Packing' }}
    </b-button>
  </div>
</template>

<script>
/**
 * Packing Form Footer to show the total order and fulfillment fee
 * and the submit button
 */
export default {
  props: {
    totalOrder: {
      type: Number,
      default: 0,
    },
    totalFulfillmentFee: {
      type: Number,
      default: 0,
    },
    isAllowSubmit: {
      type: Boolean,
      default: false,
    },
    isOnSubmit: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
     * Handles the submission of content.
     */
    async handleSubmitBulkUpload() {
      this.$emit('submit-content')
    },
  },
}
</script>
